import React, { AnchorHTMLAttributes } from 'react';
import Url from 'url-parse';

import {
  KnownService,
  KnownServiceComponentProps,
} from './known-services/known-service';

import { FogBugzCase } from './known-services/fogbugz-case';
import { GitHubCommit } from './known-services/github-commit';
import { GitHubIssue } from './known-services/github-issue';
import { GitHubPullRequest } from './known-services/github-pr';
import { KilnCase } from './known-services/kiln-case';
import { TrelloAction } from './known-services/trello-action';
import { TrelloBoard } from './known-services/trello-board';
import { TrelloCard } from './known-services/trello-card';

export class FriendlyLink extends React.Component<
  AnchorHTMLAttributes<HTMLAnchorElement>
> {
  knownServices: KnownService<KnownServiceComponentProps>[] = [
    TrelloBoard,
    TrelloAction,
    TrelloCard,
    FogBugzCase,
    KilnCase,
    GitHubCommit,
    GitHubIssue,
    GitHubPullRequest,
  ];

  render() {
    const { href, children, ...props } = this.props;
    if (!href) {
      return <a {...this.props} />;
    }

    // if href !== children then we want to show the link name that the user set
    if (href === children) {
      for (const knownService of this.knownServices) {
        const matchedValues = this.execMatch(knownService, href);
        if (matchedValues !== null) {
          const { Component, getMatchProps } = knownService;

          return <Component {...props} {...getMatchProps(matchedValues)} />;
        }
      }
    }

    return <a {...this.props} />;
  }

  execMatch = (
    { match }: KnownService<KnownServiceComponentProps>,
    url: string,
  ) => {
    const parsed = new Url(url);
    let matchedValues = [parsed.href, parsed.pathname];

    let key: keyof KnownService<KnownServiceComponentProps>['match'];
    for (key in match) {
      const expected = match[key];

      if (typeof expected === 'string') {
        if (expected !== parsed[key]) {
          return null;
        }
      } else if (expected instanceof RegExp) {
        const regexp = parsed[key];
        const results =
          typeof regexp === 'string' ? expected.exec(regexp) : null;

        if (results !== null) {
          matchedValues = [...matchedValues, ...results.slice(1)];
        } else {
          return null;
        }
      } else {
        throw Error('Invalid specification');
      }
    }

    return matchedValues;
  };
}
